import gsap from "gsap";

import { debounce } from "./functions";
import { requestScrollTriggerRefresh } from "../base/scroll";
import { breakpoints } from "@tokens/breakpoints";

export const isTouchDevice = "ontouchstart" in document.documentElement;
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
export const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const inner = {
    w: window.innerWidth,
    h: window.innerHeight,
};
export let isNavMobile = inner.w < breakpoints["nav-break"];

const header = document.querySelector<HTMLElement>(".header");
const footer = document.querySelector<HTMLElement>(".footer");

export let varGutter: number = 0;
export let varGap: number = 0;
export let headerHeight: number = header ? header.offsetHeight : 0;
export let footerHeight: number = footer ? footer.offsetHeight : 0;

export function calcResize(triggerScrollRefresh: boolean = true) {
    inner.w = window.innerWidth;
    inner.h = window.innerHeight;

    isNavMobile = inner.w < breakpoints["nav-break"];

    varGutter = convertMaxProp("--gutter");
    varGap = convertMaxProp("--gap");

    calcHeaderHeight();
    calcFooterHeight();

    if (triggerScrollRefresh) requestScrollTriggerRefresh(100);
}

export function calcHeaderHeight() {
    if (header) {
        headerHeight = header.offsetHeight;
        gsap.set(":root", { "--header-height": headerHeight + "px" });

        return headerHeight;
    }
}

export function calcFooterHeight() {
    if (footer) {
        footerHeight = footer.offsetHeight;
        gsap.set(":root", { "--footer-height": footerHeight + "px" });

        return footerHeight;
    }
}

export function convertMaxProp(maxProp: string) {
    const probe = document.createElement("div");
    probe.style.position = "absolute";
    probe.style.visibility = "hidden";
    probe.style.pointerEvents = "none";
    probe.style.width = `var(${maxProp})`;

    document.documentElement.appendChild(probe);
    const value = probe.getBoundingClientRect().width;
    probe.remove();

    return value;
}

function resize() {
    if (isTouchDevice) {
        const isSignificantResize = window.innerHeight > inner.h + inner.h * 0.3 || window.innerHeight < inner.h - inner.h * 0.3;
        if (isSignificantResize) calcResize();
    } else calcResize(true);
}

export function initVariables() {
    calcResize(false);
    const debouncedResize = debounce(resize, 300);
    window.addEventListener("resize", debouncedResize);
}
